module.exports = __webpack_public_path__ + "static/media/vf-button-shoes.67e461d8.svg";